export const ADD_EVENT_INFO = "ADD_EVENT_INFO"
export const ADD_EVENT_INFO_SUCCESS = "ADD_EVENT_INFO_SUCCESS"
export const ADD_EVENT_INFO_FAILED = "ADD_EVENT_INFO_FAILED"

export const GET_EVENT_INFO = "GET_EVENT_INFO"
export const GET_EVENT_INFO_SUCCESS = "GET_EVENT_INFO_SUCCESS"
export const GET_EVENT_INFO_FAILED = "GET_EVENT_INFO_FAILED"
export const RESET_EVENT_INFO = "RESET_EVENT_INFO"

export const UPDATE_EVENT_INFO = "UPDATE_EVENT_INFO"
export const UPDATE_EVENT_INFO_SUCCESS = "UPDATE_EVENT_INFO_SUCCESS"
export const UPDATE_EVENT_INFO_FAILED = "UPDATE_EVENT_INFO_FAILED"

export const GET_RSVP_WEBPAGE_CONFIG = "GET_RSVP_WEBPAGE_CONFIG"
export const GET_RSVP_WEBPAGE_CONFIG_SUCCESS = "GET_RSVP_WEBPAGE_CONFIG_SUCCESS"
export const GET_RSVP_WEBPAGE_CONFIG_FAILED = "GET_RSVP_WEBPAGE_CONFIG_FAILED"

export const GET_RSVP_BOOKED_SPOTS = "GET_RSVP_BOOKED_SPOTS"
export const GET_RSVP_BOOKED_SPOTS_SUCCESS = "GET_RSVP_BOOKED_SPOTS_SUCCESS"
export const GET_RSVP_BOOKED_SPOTS_FAILED = "GET_RSVP_BOOKED_SPOTS_FAILED"

export const GET_EVENT_INFO_LIST = "GET_EVENT_INFO_LIST"
export const GET_EVENT_INFO_LIST_SUCCESS = "GET_EVENT_INFO_LIST_SUCCESS"
export const GET_EVENT_INFO_LIST_FAILED = "GET_EVENT_INFO_LIST_FAILED"
export const RESET_EVENT_INFO_LIST = "RESET_EVENT_INFO_LIST"
